import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as DictionariesIcon } from "icons/stats/dictionaries.svg";
import { ReactComponent as DocumentsIcon } from "icons/stats/documents.svg";
import { ReactComponent as FoldersIcon } from "icons/stats/folders.svg";
import { ReactComponent as UsersIcon } from "icons/stats/users.svg";

const WorkspaceStat = ({ type, values, hideDivider }) => {
  let icon;
  let title;
  let description;
  const workspaceClass = type.replace(new RegExp("-", "g"), "_");
  switch (type) {
    case "folders":
      icon = <FoldersIcon />;
      title = `${values[0]}`;
      description = "Number of Folders";
      break;
    case "documents":
      icon = <DocumentsIcon />;
      title = `${values[0]}`;
      description = "Number of Documents";
      break;
    case "dictionaries":
      icon = <DictionariesIcon />;
      title = `${values[0]}`;
      description = "Number of Dictionaries";
      break;
    case "users":
    default:
      icon = <UsersIcon />;
      title = `${values[0]}`;
      description = "Licensed Users";
      break;
  }
  return (
    <div className="workspace_stat" data-testid="workspace-stat">
      <div className="workspace_stat_content">
        <span className={`workspace_stat_content__icon ${workspaceClass}`}>
          {icon}
        </span>
        <span className="workspace_stat_content__title">{title}</span>
        <span className="workspace_stat_content__description">
          {description}
        </span>
      </div>
      {hideDivider || <div className="workspace_stat__divider" />}
    </div>
  );
};

export default WorkspaceStat;

WorkspaceStat.propTypes = {
  type: PropTypes.string.isRequired,
  values: PropTypes.oneOfType([PropTypes.array]).isRequired,
  hideDivider: PropTypes.bool,
};
